import React from 'react'
import { parseISO } from 'date-fns';
import InlineTimer from '@components/timers/InlineTimer';
import useServerTime from '@hooks/useServerTime';

export default function BidderDashboardTimeField({ bidEndTime, startServerMS }) {
  const serverMS = useServerTime()
  return <InlineTimer startTime={serverMS || startServerMS} endTime={parseISO(bidEndTime).getTime()} rootClass="text-sm sm:text-base" />
}